import repositories from '..';

const resource = '/system/roles';

export default {
  getInitData: () => repositories.get(`${resource}/data/init`),
};
